import { ReactNode } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import { RiExpandDiagonalSLine } from '@remixicon/react';
import classNames from 'classnames';

import { ButtonIcon, Flex, FlexProps, Text } from '@backstage/ui';

const styles = createStyles({
  root: {
    position: 'relative',
    flexDirection: 'column',
    gap: 'var(--bui-space-1)',
  },
  header: {
    alignItems: 'center',
    gap: 'var(--bui-space-2)',
  },
  title: {
    flex: 1,
    minWidth: 0,
  },
  expandButton: {
    flexShrink: 0,
    alignSelf: 'start',
    marginRight: '-6px', // Alignment adjustment
  },
});

export interface ActivityItemPanelProps
  extends Omit<FlexProps, 'title'>,
    WithStyles<typeof styles> {
  title?: ReactNode;
  onExpand?: () => void;
}

const ActivityItemPanel = ({
  classes,
  className,
  children,
  onExpand,
  title,
  ...props
}: ActivityItemPanelProps) => {
  return (
    <Flex className={classNames(classes.root, className)} {...props}>
      {(title || onExpand) && (
        <Flex className={classes.header}>
          {title && (
            <Text variant="body-medium" weight="bold" className={classes.title}>
              {title}
            </Text>
          )}
          {onExpand && (
            <ButtonIcon
              variant="tertiary"
              size="small"
              icon={<RiExpandDiagonalSLine />}
              onClick={onExpand}
              className={classes.expandButton}
              aria-label="Expand"
            />
          )}
        </Flex>
      )}
      {children}
    </Flex>
  );
};

export default withStyles(styles)(ActivityItemPanel);
